package one.healthium.insights.domain.models

data class MealModel(
    val title: String?,
    val description: String?,
    val details: List<MealDetailsModel>,
    val nutrition: MealNutritionModel?,
)

data class MealDetailsModel(
    val title: String?,
    val text: String?,
)

data class MealNutritionModel(
    val product: String?,
    val portion: Float?,
    val calories: Float?,
    val fat: Float?,
    val carbs: Float?,
    val fiber: Float?,
    val protein: Float?,
)
